import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Skip token for login, register, and auth-code validation endpoints
  const isAuthEndpoint = req.url.includes('/auth/login') || req.url.includes('/auth/register');
  const isAuthCodeValidate = req.url.includes('/auth-codes/validate');

  let request = req;

  // Only add token for non-auth endpoints
  if (!isAuthEndpoint && !isAuthCodeValidate) {
    const token = authService.getAccessToken();

    if (token) {
      request = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }

  return next(request).pipe(
    catchError((error) => {
      // 401 Unauthorized — token expired or invalid mid-session
      if (error.status === 401 && !isAuthEndpoint && !isAuthCodeValidate) {
        authService.clearAuth();
        router.navigate(['/auth/login']);
      }
      return throwError(() => error);
    })
  );
};